import type { SxProps, AlertProps } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';

type Props = {
  heading: string;
  message: string;
  severity?: AlertProps['severity'];
  titleSx?: SxProps;
};

export function NotAvailable({ heading, message, severity = 'error', titleSx = {} }: Props) {
  return (
    <Alert severity={severity}>
      <AlertTitle sx={titleSx}>{heading}</AlertTitle>

      {message}
    </Alert>
  );
}
